import React from 'react';

export default function LdaTreeToolbar({ count, progress, onExpandAll, onCollapseAll }) {
  return <div className="lda-tree-toolbar">
    <div><strong>{count} livrable{count > 1 ? 's' : ''}</strong><span>{progress}% diffusés</span></div>
    <div><button type="button" onClick={onExpandAll}>Tout déplier</button><button type="button" onClick={onCollapseAll}>Tout replier</button></div>
  </div>;
}
